import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal as BaseModal } from "native-base";
import { isWeb } from "@madmedical/utils";
import useResponsive from "../util/useResponsive";
const Modal = ({ children, open, onClose, size = "md", hasCloseButton = true, }) => {
    const { isSmallScreen } = useResponsive();
    return (_jsx(BaseModal, Object.assign({ isOpen: open, onClose: onClose, size: isSmallScreen ? "full" : size, avoidKeyboard: true, safeArea: true, useRNModal: true, mt: 6, pb: 6 }, { children: _jsxs(BaseModal.Content, Object.assign({ maxHeight: isWeb ? (isSmallScreen ? "100vh" : "72vh") : "100%", height: isWeb ? (isSmallScreen ? "100vh" : "auto") : "100%", bgColor: "white" }, { children: [hasCloseButton && _jsx(BaseModal.CloseButton, {}), children] })) })));
};
export default Modal;
